/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_PURCHASE,
  LOAD_PURCHASE_SUCCESS,
  LOAD_PURCHASE_ERROR,
  CREATE_PURCHASE,
  CREATE_PURCHASE_SUCCESS,
  CREATE_PURCHASE_ERROR,
  UPDATE_PURCHASE,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,
  DELETE_PURCHASE,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_ERROR,
  LOAD_PURCHASE_RECORDS_META_DATA,
  LOAD_PURCHASE_RECORDS_META_DATA_SUCCESS,
  LOAD_PURCHASE_RECORDS_META_DATA_ERROR,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PURCHASE_PARTIES_CATEGORY,
  LOAD_PURCHASE_PARTIES_CATEGORY_SUCCESS,
  LOAD_PURCHASE_PARTIES_CATEGORY_ERROR,
  CREATE_PURCHASE_PARTIES_CATEGORY,
  CREATE_PURCHASE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_DASHBOARD_TRANSACTION,
  LOAD_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_DASHBOARD_TRANSACTION_ERROR,
  LOAD_TOTAL_BALANCE,
  LOAD_TOTAL_BALANCE_SUCCESS,
  LOAD_TOTAL_BALANCE_ERROR,
} from "./constants";

// load parties
export function loadPurchaseOrders(partiesList) {
  return {
    type: LOAD_PURCHASE,
    partiesList,
  };
}

export function loadPurchaseOrdersSuccess(parties_list, success) {
  return {
    type: LOAD_PURCHASE_SUCCESS,
    parties_list,
    success,
  };
}

export function loadPurchaseOrdersError(error) {
  return {
    type: LOAD_PURCHASE_ERROR,
    error,
  };
}

// load parties
export function loadDashboardTransactions(transactionsList) {
  return {
    type: LOAD_DASHBOARD_TRANSACTION,
    transactionsList,
  };
}

export function loadDashboardTransactionsSuccess(
  dashboard_transactions,
  success
) {
  return {
    type: LOAD_DASHBOARD_TRANSACTION_SUCCESS,
    dashboard_transactions,
    success,
  };
}

export function loadDashboardTransactionsError(error) {
  return {
    type: LOAD_DASHBOARD_TRANSACTION_ERROR,
    error,
  };
}

// load total balance
export function loadTotalBalance(transactionsList) {
  return {
    type: LOAD_TOTAL_BALANCE,
    transactionsList,
  };
}

export function loadTotalBalanceSuccess(total_balance_list, success) {
  return {
    type: LOAD_TOTAL_BALANCE_SUCCESS,
    total_balance_list,
    success,
  };
}

export function loadTotalBalanceError(error) {
  return {
    type: LOAD_TOTAL_BALANCE_ERROR,
    error,
  };
}

// load pary address
export function loadPartyVendorAddress(partiesList) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS,
    partiesList,
  };
}

export function loadPartyVendorAddressSuccess(party_address_list, success) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
    party_address_list,
    success,
  };
}

export function loadPartyVendorAddressError(error) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// Category

export function loadPartiesCategory(categoryList) {
  return {
    type: LOAD_PURCHASE_PARTIES_CATEGORY,
    categoryList,
  };
}

export function loadPartiesCategorySuccess(category_list, success) {
  return {
    type: LOAD_PURCHASE_PARTIES_CATEGORY_SUCCESS,
    category_list,
    success,
  };
}

export function loadPartiesCategoryError(error) {
  return {
    type: LOAD_PURCHASE_PARTIES_CATEGORY_ERROR,
    error,
  };
}

//category list
export function createPartiesCategoryList(categoryList) {
  return {
    type: CREATE_PURCHASE_PARTIES_CATEGORY,
    categoryList,
  };
}

export function createPartiesCategoryListSuccess(categoryList, success) {
  return {
    type: CREATE_PURCHASE_PARTIES_CATEGORY_SUCCESS,
    categoryList,
    success,
  };
}

export function createPartiesCategoryListError(error) {
  return {
    type: CREATE_PURCHASE_PARTIES_CATEGORY_ERROR,
    error,
  };
}

// party address create
export function createPartyVendorAddress(partyAddress) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS,
    partyAddress,
  };
}

export function createPartyVendorAddressSuccess(partyAddress, success) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
    partyAddress,
    success,
  };
}

export function createPartyVendorAddressError(error) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// load parties
export function createPurchaseList(partiesList) {
  return {
    type: CREATE_PURCHASE,
    partiesList,
  };
}

export function createPurchaseListSuccess(partiesList, success) {
  return {
    type: CREATE_PURCHASE_SUCCESS,
    partiesList,
    success,
  };
}

export function createPurchaseListError(error) {
  return {
    type: CREATE_PURCHASE_ERROR,
    error,
  };
}
// load parties
export function updatePurchaseList(partiesList) {
  return {
    type: UPDATE_PURCHASE,
    partiesList,
  };
}

export function updatePurchaseListSuccess(partiesList, success) {
  return {
    type: UPDATE_PURCHASE_SUCCESS,
    partiesList,
    success,
  };
}

export function updatePurchaseListError(error) {
  return {
    type: UPDATE_PURCHASE_ERROR,
    error,
  };
}
// load parties
export function deletePurchaseList(partiesList) {
  return {
    type: DELETE_PURCHASE,
    partiesList,
  };
}

export function deletePurchaseListSuccess(partiesList, success) {
  return {
    type: DELETE_PURCHASE_SUCCESS,
    partiesList,
    success,
  };
}

export function deletePurchaseListError(error) {
  return {
    type: DELETE_PURCHASE_ERROR,
    error,
  };
}

// load parties transaction
export function loadPartiesTransaction(partiesList) {
  return {
    type: LOAD_PARTIES_TRANSACTION,
    partiesList,
  };
}

export function loadPartiesTransactionSuccess(
  parties_transaction_list,
  success
) {
  return {
    type: LOAD_PARTIES_TRANSACTION_SUCCESS,
    parties_transaction_list,
    success,
  };
}

export function loadPartiesTransactionError(error) {
  return {
    type: LOAD_PARTIES_TRANSACTION_ERROR,
    error,
  };
}

export function loadPurchaseRecordsMetaData() {
  return {
    type: LOAD_PURCHASE_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPurchaseRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_PURCHASE_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPurchaseRecordsMetaDataError(error) {
  return {
    type: LOAD_PURCHASE_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadPurchaseOrders,
  loadPurchaseOrdersSuccess,
  loadPurchaseOrdersError,

  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,

  loadTotalBalance,
  loadTotalBalanceSuccess,
  loadTotalBalanceError,

  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,

  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,

  createPartiesCategoryList,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,

  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,

  createPurchaseList,
  createPurchaseListSuccess,
  createPurchaseListError,

  createPartyVendorAddress,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,

  updatePurchaseList,
  updatePurchaseListSuccess,
  updatePurchaseListError,

  deletePurchaseList,
  deletePurchaseListSuccess,
  deletePurchaseListError,

  loadPurchaseRecordsMetaData,
  loadPurchaseRecordsMetaDataSuccess,
  loadPurchaseRecordsMetaDataError,
};

export default actions;
